import { graphql } from "gatsby";
import type { MicroCopyValues } from "@bmi-digital/dxb-microcopies";
import type { PayloadMicroCopy } from "../types/payload";

export type MicroCopy = Pick<PayloadMicroCopy, "key" | "value">;

export type GetMicroCopy = (
  path: MicroCopyValues | string,
  variables?: Record<string, string>
) => string;

export const fallbackGetMicroCopy: GetMicroCopy = (path) => `MC: ${path}`;

export const generateGetMicroCopy = (microCopy: MicroCopy[]): GetMicroCopy => {
  return (path, variables = {}) => {
    const copyNode = microCopy.find((node) => node.key === path);
    const copy = copyNode ? copyNode.value : fallbackGetMicroCopy(path);

    return Object.entries(variables).reduce(
      (acc, [key, value]) => acc.replace(`{{${key}}}`, value),
      copy
    );
  };
};

export const query = graphql`
  fragment MicroCopyFragment on PayloadMicroCopy {
    key
    value
  }
`;
